import { IconBulletListOutline18 as List } from "nucleo-ui-outline-18"

import { ShortcutSymbols } from "@productlane/lib/src/shortcut-symbols"

import type { SlashCommandDefinition } from "../types"
import { iconClassName } from "../constants"

export const bulletedListCommand: SlashCommandDefinition = {
	key: "bulleted-list",
	title: "Bulleted list",
	icon: <List strokeWidth={1.75} className={iconClassName} />,
	command: ({ editor, range }) => {
		editor.chain().focus().deleteRange(range).toggleBulletList().run()
	},
	group: "lists",
	shortcutIcons: [
		ShortcutSymbols.CMD,
		ShortcutSymbols.SHIFT,
		ShortcutSymbols[8],
	],
}
